var map = {
	"./../../routes/account/account.module": [
		"./src/app/routes/account/account.module.ts",
		"routes-account-account-module"
	],
	"./../../routes/applications/applications.module": [
		"./src/app/routes/applications/applications.module.ts",
		"common",
		"routes-applications-applications-module"
	],
	"./../../routes/back-office/back-office.module": [
		"./src/app/routes/back-office/back-office.module.ts",
		"common",
		"routes-back-office-back-office-module"
	],
	"./../../routes/messages/messages.module": [
		"./src/app/routes/messages/messages.module.ts",
		"common",
		"routes-messages-messages-module"
	],
	"./../../routes/settings/settings.module": [
		"./src/app/routes/settings/settings.module.ts",
		"common",
		"routes-settings-settings-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;